(function (angular){

    'use strict';

    angular.module('app')
        .controller('app.contactUsFormController', ['$uibModal', 'util', 'ui', '$http', contactUsFormController]);

    function contactUsFormController($uibModal, util, ui, $http) {
        var vm = this;
        // Properties
        vm.contactUs = {
            name: '',
            email: '',
            message:'',
            planEmail: planEmail,
            planName: planName
        };
        vm.formDefaults = {};

        // Actions
        vm.sendEmail = sendEmail;

        onInit();

        function onInit() {
            vm.formDefaults = angular.copy(vm.contactUs);
            getYear();
        }

        function getYear(){
            var today = new Date();
            vm.currentYear = today.getFullYear();
        }

        function sendEmail(contactUsForm) {
            
            ui.block();

            sendContactUsEmail(vm.contactUs)
                .then(function successful(response) {

                    $uibModal.open({
                        templateUrl: '/app/layout/contact-us/modals/email-sent-modal.html',
                        keyboard: false,
                        windowTopClass: 'patolus-modal-backdrop'
                    });

                    formReset(contactUsForm);
                })
                .catch(function rejected(response) {
                    ui.handleError(response);
                })
                .finally(function final() {
                    ui.unblock();
                })
        }

        function sendContactUsEmail(data) {

            var url = environment.salesApiUrl + 'contact-us/send-email';

            return $http.post(url, data);
        }
       
        function formReset(contactUsForm) {
            
            // Load form defaults
            vm.contactUs = angular.copy(vm.formDefaults);

            // Reset form validation aspects
            contactUsForm.$setPristine();
            contactUsForm.$setUntouched();
        }
    }
    
}(angular));